import React from 'react'
import s from './hero.module.css'
import { withPrefix } from 'gatsby'
import Btn from '../../components/buttons/buttons'
import { ArrowDown } from '../../svg/arrow_down'
import { GTMEvents } from '../../lib/GTMevents'

const Hero = props => {
  const onClick = () => {
    if (props.GTMOption.section.length) {
      GTMEvents.RetirementTabBtn(
        props.isGTMNameActive ? props.GTMNameEvent : 'banner_click',
        props.GTMOption.section,
        props.GTMOption.sub_sec,
        props.GTMOption.option,
        props.GTMOption.location
      )
    } else if (props.customGTM === false) {
      GTMEvents.ContributionsAndFundBtn(props.title, props.linkLabel)
    }
    props.event()
  }

  return (
    <div
      className={`flex direction-column ${
        props.centerTextContent ? 'justify-center ' : 'justify-between'
      } justify-center@md tw-pt-8 tw-pt-0@lg tw-pb-4 tw-pb-0@lg ${s.hero} ${
        props.overlay === true ? s.heroShadow : ''
      } ${
        props.className
      }`} /* OVERLAY CAPA NEGRA CON OPACITY ANTES DE LA IMAGEN */
    >
      {props.image /* IMAGEN SOLO SE MUESTRA EN DESKTOP */ && (
        <div className={`${s.heroImageWrap} dn db@lg`}>
          <div
            className={
              'containerWrap relative h-100 flex@md justify-end items-end'
            }
          >
            <img
              alt=""
              src={withPrefix('/images/' + props.image)}
              className={`${s.heroImage} ${props.imageClassName}`}
            />
          </div>
        </div>
      )}

      {props.imageMobile /* IMAGEN SOLO SE MUESTRA EN MOBILE */ && (
        <img
          alt=""
          src={withPrefix('/images/' + props.imageMobile)}
          className={`${s.heroImageMobile} db dn@lg ${
            props.imageMobileClassName ? props.imageMobileClassName : ''
          }`}
        />
      )}

      {props.imageBanner /* IMAGEN SOLO SE MUESTRA EN DESKTOP TIPO BANNER */ && (
        <img
          alt=""
          src={withPrefix('/images/' + props.imageBanner)}
          className={`dn db@lg ${s.heroImageBanner}`}
        />
      )}

      {props.imageBannerMobile /* IMAGEN SOLO SE MUESTRA EN MOBILE TIPO BANNER */ && (
        <img
          alt=""
          src={withPrefix('/images/' + props.imageBannerMobile)}
          className={`db dn@lg ${s.heroImageBannerMobile}`}
        />
      )}

      {/* CONTAINER CONTENIDO */}
      <div className={`containerWrap ${s.heroContent}`}>
        <div className={`flex justify-start w-100`}>
          <div className={`w-${props.widthTextContent} w-50@md`}>
            {props.preTitle /* TEXTO PRETITLE (antes de Titulo) */ && (
              <div
                className={`font-family-primary fw-4 tw-f-14 tw-f-14@md tw-mb-2 ${
                  props.preTitleColor
                } ${props.preTitleColor ? props.preTitleColor : 'c-gray--4'}`}
              >
                {props.preTitle}
              </div>
            )}
            {props.title /* TEXTO TITLE (Titulo) */ && (
              <h1 className="font-family-secondary fw-7 tw-f-24 tw-f-36@md tw-mt-0 tw-mb-2">
                <span
                  className={`${
                    props.titleColor ? props.titleColor : 'c-gray--4'
                  }`}
                >
                  {props.title}{' '}
                </span>
                {props.highlighted && (
                  <span
                    className={`${
                      props.highlightedColor
                        ? props.highlightedColor
                        : 'c-orange-0'
                    }`}
                  >
                    {props.highlighted}
                  </span>
                )}
              </h1>
            )}
            {props.titleImage && (
              <img
                alt=""
                src={withPrefix('/images/' + props.titleImage)}
                className="tw-mt-0 tw-mb-2"
              />
            )}
            {props.description /* TEXTO DESCRIPCION */ && (
              <div
                className={`font-family-primary tw-f-16 tw-f-18@md ${
                  props.descriptionColor ? props.descriptionColor : 'c-gray--4'
                }`}
              >
                {props.description}
              </div>
            )}
          </div>
        </div>
      </div>

      {props.link /* BOTON / LINK BOTON (si hay link hay boton) */ && (
        <div
          onClick={onClick}
          className={`containerWrap ${s.heroContent} tw-mt-8@md`}
        >
          <div className={`tw-mt-8@md w-100 w-50@md`}>
            <Btn
              type="link"
              href={props.link}
              target="_blank"
              size="medium"
              label={props.linkLabel}
              className="font-family-secondary fw-6 tw-f-18 tw-f-18@md tw-px-4 tw-px-8@lg tw-py-4 block text-center w-100 w-auto@md"
            />
          </div>
        </div>
      )}

      {props.arrowDown /* ICONO FLECHA ABAJO ANIMADA */ && (
        <div className={`containerWrap ${s.heroContent} tw-mt-8@md`}>
          <div className={`w-100 w-50@md`}>
            <ArrowDown
              fill={props.arrowDownColor}
              className={`${s.fadeMoveDown} ${
                props.arrowDownClassName ? props.arrowDownClassName : ''
              }`}
            />
          </div>
        </div>
      )}
    </div>
  )
}

Hero.defaultProps = {
  GTMOption: { section: '', sub_sec: '', option: '', location: '' },
  isGTMNameActive: false,
  GTMNameEvent: '',
  customGTM: false,
  preTitle: false, //  Texto antes del titulo
  preTitleColor: '', //  Color del Pre titulo por defecto color c-gray--4
  title: false, //  Titulo
  titleColor: '', //  Color del Titulo
  titleImage: false, // Titulo como imagen
  highlighted: false, //  Texto Titulo con highlighted
  highlightedColor: '', //  Color del highlighted por defecto color c-orange-0
  description: false, //  Descripción
  descriptionColor: '', //  Color de la Descripción por defecto color c-gray--4
  image: '', // Imagen para desktop
  imageClassName: '', // Clase CSS Imagen para desktop
  imageMobile: false, // Imagen para mobile
  imageMobileClassName: '', // Clase CSS Imagen para mobile
  imageBanner: '', // Imagen de fondo para desktop expandido
  imageBannerMobile: '', // Imagen de fondo para mobile expandido
  linkLabel: 'Ver mas', // Texto para botón
  link: '', // Url para el botón
  overlay: false, // Muestra capa background con opacidad 0.7 encima de la imagen como sombra
  arrowDown: false, // Muestra icono flecha vertical apuntando hacia abajo
  arrowDownColor: '#000', // Color del icono arrowDown
  arrowDownClassName: '', // Clase CSS Imagen para ArrowDown
  className: '', // Clase CSS
  centerTextContent: false, // Texto centrado verticalmente
  widthTextContent: '80', // Width del contenido de texto
  event: () => {}, //Se usa para mandar el GTM de eventos atm
}

export default Hero
